// Máscara VISUAL de dominios de correo para la demo Kit Digital.
//
// Reescribe, solo en pantalla (nodos de texto del DOM), el dominio de
// cualquier email por el del beneficiario (scu-pracom-andalucia.com). Los
// datos reales NO se tocan: los correos son la credencial de login de los
// trabajadores y además el sync de Freematica los repondría.
//
// - Activa para TODAS las sesiones del dashboard mientras MASCARA_ACTIVA
//   sea true (interruptor único para apagarla tras la auditoría).
// - No toca <input>/<textarea> (los formularios de edición muestran y
//   guardan siempre el dato real).
// - El propio email del usuario logueado no se enmascara (coherencia con
//   la sesión iniciada).
import { useContext, useEffect } from 'react';
import { AuthContext } from '../../store/AuthContext';

const DOMINIO_DEMO = 'scu-pracom-andalucia.com';
// Interruptor global de la máscara. Ponerlo a false la desactiva para todos.
// Desactivada 2026-07-10: se decidió mostrar los correos reales.
const MASCARA_ACTIVA = false;
const EMAIL_RE = /([A-Za-z0-9._%+-]+)@([A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;
const TAGS_EXCLUIDOS = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT']);

const EmailDomainMask = () => {
  const { currentUser } = useContext(AuthContext);
  const emailSesion = (currentUser?.email || '').toLowerCase();
  const activo = MASCARA_ACTIVA && !!currentUser;

  useEffect(() => {
    if (!activo) return undefined;

    const enmascarar = (texto) =>
      texto.replace(EMAIL_RE, (completo, local, dominio) => {
        if (completo.toLowerCase() === emailSesion) return completo;
        if (dominio.toLowerCase() === DOMINIO_DEMO) return completo;
        return `${local}@${DOMINIO_DEMO}`;
      });

    const procesarTexto = (nodo) => {
      const valor = nodo.nodeValue;
      if (!valor || valor.indexOf('@') === -1) return;
      const padre = nodo.parentElement;
      if (padre && TAGS_EXCLUIDOS.has(padre.tagName)) return;
      const nuevo = enmascarar(valor);
      // Si no cambia nada no se escribe: corta el ciclo de mutaciones.
      if (nuevo !== valor) nodo.nodeValue = nuevo;
    };

    const procesarNodo = (nodo) => {
      if (nodo.nodeType === Node.TEXT_NODE) {
        procesarTexto(nodo);
        return;
      }
      if (nodo.nodeType !== Node.ELEMENT_NODE || TAGS_EXCLUIDOS.has(nodo.nodeName)) return;
      const walker = document.createTreeWalker(nodo, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) =>
          n.nodeValue && n.nodeValue.indexOf('@') !== -1
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_SKIP,
      });
      const pendientes = [];
      while (walker.nextNode()) pendientes.push(walker.currentNode);
      pendientes.forEach(procesarTexto);
    };

    procesarNodo(document.body);
    const observer = new MutationObserver((mutaciones) => {
      for (const m of mutaciones) {
        if (m.type === 'characterData') procesarTexto(m.target);
        if (m.addedNodes) m.addedNodes.forEach(procesarNodo);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [activo, emailSesion]);

  return null;
};

export default EmailDomainMask;
